export const CREATE_CURRENCY_REQUEST = "CREATE_CURRENCY_REQUEST";
export const FETCH_CURRENCIES_REQUEST = "FETCH_CURRENCIES_REQUEST";
export const UPDATE_CURRENCY_REQUEST = "UPDATE_CURRENCY_REQUEST";
